import React from "react";

export const FlowerOfLife = ({ size = 360, color = "#D4AF37", className = "" }) => {
  const r = 40;
  const cx = size / 2;
  const cy = size / 2;
  const positions = [];
  positions.push({ x: cx, y: cy });
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 3) * i;
    positions.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
  }
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 3) * i + Math.PI / 6;
    positions.push({ x: cx + r * Math.sqrt(3) * Math.cos(a), y: cy + r * Math.sqrt(3) * Math.sin(a) });
  }
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 3) * i;
    positions.push({ x: cx + 2 * r * Math.cos(a), y: cy + 2 * r * Math.sin(a) });
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      fill="none"
      stroke={color}
      strokeWidth="0.7"
      aria-hidden="true"
    >
      <defs>
        <filter id="fol-glow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="2" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#fol-glow)" opacity="0.85">
        {positions.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r={r} />
        ))}
      </g>
    </svg>
  );
};

export const CircuitBackground = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 800 600"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <g stroke="#00F0FF" strokeWidth="0.6" fill="none" opacity="0.35">
      <path className="circuit-line" d="M0 80 L180 80 L210 110 L420 110 L450 80 L800 80" />
      <path className="circuit-line" d="M0 220 L120 220 L150 250 L380 250 L410 220 L600 220 L630 250 L800 250" />
      <path className="circuit-line" d="M0 360 L240 360 L270 390 L520 390 L550 360 L800 360" />
      <path className="circuit-line" d="M0 500 L160 500 L190 470 L460 470 L490 500 L800 500" />
      <path className="circuit-line" d="M100 0 L100 140 L130 170 L130 600" />
      <path className="circuit-line" d="M340 0 L340 90 L370 120 L370 600" />
      <path className="circuit-line" d="M580 0 L580 200 L610 230 L610 600" />
      <path className="circuit-line" d="M720 0 L720 320 L690 350 L690 600" />
    </g>
    <g fill="#00F0FF" opacity="0.7">
      <circle cx="180" cy="80" r="2.5" />
      <circle cx="450" cy="80" r="2.5" />
      <circle cx="380" cy="250" r="2.5" />
      <circle cx="630" cy="250" r="2.5" />
      <circle cx="270" cy="390" r="2.5" />
      <circle cx="550" cy="360" r="2.5" />
      <circle cx="190" cy="470" r="2.5" />
      <circle cx="490" cy="500" r="2.5" />
    </g>
  </svg>
);

export const RuneDivider = ({ glyph = "ᚠ ᚢ ᚦ" }) => (
  <div className="divider-rune my-12 text-xs font-display" data-testid="rune-divider">
    <span>{glyph}</span>
  </div>
);
